<script>
    import R, {LOADER} from "../lib/requests";
    import app from "../stores/app";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import ServiceEditModal from "./ServiceEditModal.svelte";
    import ServicesTable from "./ServicesTable.svelte";
    import WsServiceSelectModal from "./WsServiceSelectModal.svelte";
    import SubscriptionEditModal from "./SubscriptionEditModal.svelte";


    export let clientId = null;
    export let projectId = null;
    export let searchParams = {};
    export let services = null;

    let serviceId = 0;
    let wsServiceId = null;
    let editServiceId = null;
    let renewServiceId = null;
    let entitiesServiceId = null;
    let showWsServiceModal = false;

    export const create = () => {
        showWsServiceModal = true;
    }

    const load = (loader = LOADER.PAGE) => {

        const onSuccess = result => {
            services = result;
        }

        const onFailure = err => {
        };

        R.handle(R.service.index, searchParams, onSuccess, onFailure, loader);
    };


    const onClick = (service) => {
        serviceId = service.id;
    }


    const onEdit = ({detail}) => {
        serviceId = detail.id;
        editServiceId = detail.id;
    }

    const closeEdit = (param) => {
        editServiceId = null;

        if (param) {
            let item = services.find(x => x.id == param.id);
            if (item) {
                item.name = param.name;
                item.price = param.price;
                item.is_active = param.is_active;
                item.subscription = param.subscription;
                item.tags = param.tags;
                item.users = param.users;

                services = services;
            } else {
                load(LOADER.NONE);
            }
        }
    }

    const onRenew = ({detail}) => {
        renewServiceId = detail.id;
    }

    const closeRenew = (param) => {
        renewServiceId = null;

        if (param) {
            let service = services.find(x => x.id == param.service_id);
            if (service) {
                if (service.subscriptions) {
                    let subscription = service.subscriptions.find(x => x.id == param.id);
                    if (subscription) {
                        subscription.price = param.price;
                        subscription.start_at = param.start_at;
                        subscription.end_at = param.end_at;
                        subscription.charge_id = param.charge_id;
                    } else {
                        service.subscriptions = [param, ...service.subscriptions];
                    }
                }

                service.start_at = param.start_at;
                service.expires_at = param.end_at;
                service.subscription = param;

                services = services;
            }
        }
    }

    const onDelete = ({detail}) => {
        Alert.delete("Διαγραφή", `Να διαγραφεί η υπηρεσία "${detail.name}";`, () => deleteService(detail.id));
    }

    const deleteService = (id) => {
        const onSuccess = result => {
            services = services.filter(x => x.id != result);
            Notifier.showMessage("Η υπηρεσία διαγράφτηκε");
        }

        const onFailure = err => {
        };

        R.handle(R.service.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    const updateService = (service) => {
        let srv = services.find(x => x.id === service.id);
        if (!srv) {
            services = [service, ...services];
        } else {
            srv.name = service.name;
        }
        serviceId = service.id;
    }


    const selectWsService = param => {
        showWsServiceModal = false;
        wsServiceId = param ? param.id : null;
        editServiceId = param ? 0 : null;
    }

    if (!services) {
        load();
    }
</script>

{#if services}
    {#if $app.device === 'lg' || $app.device === 'md'}
        <ServicesTable {services} on:edit={ onEdit } on:renew={ onRenew } on:delete={ onDelete }/>
    {/if}
{/if}

{#if showWsServiceModal}
    <WsServiceSelectModal closeCallback="{ selectWsService }"/>
{/if}
{#if editServiceId != null}
    <ServiceEditModal serviceId="{ editServiceId }" {wsServiceId} {clientId} {projectId} closeCallback="{ closeEdit }"/>
{/if}
{#if renewServiceId != null}
    <SubscriptionEditModal serviceId="{ renewServiceId }" closeCallback="{ closeRenew }"/>
{/if}

